/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";

import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";

import {PrimaryText} from "components/Text";
import DialogBox from "components/DialogBox";
import {
  AddFaq,
  EditFaq,
  Search
} from "./components";
import {SecondaryText} from "components/Text";

const ManageBlogFaqs = ({
  contentId,
  faqsList,
  setFaqData,
  toggleAddFaqPopup,
  token,
  setToggleAddFaqPopup,
  toggleEditFaqPopup,
  setToggleEditFaqPopup,
  editFaq,
  listAttachedFaqs,
  listFaqs,
  attachNewFaq
}) => {
  return (
    <FaqsWrapper>
      <FaqsHeader>
        <PrimaryText
          additionalStyles="margin: 0;"
          fontWeight="bold"
        >
          Faqs
        </PrimaryText>
        <CreateFaqButton
          onClick={(e) => {
            e.preventDefault();
            setToggleAddFaqPopup(!toggleAddFaqPopup);
          }}
        >
          Add Faq
        </CreateFaqButton>
      </FaqsHeader>
      <FaqsListingContainer>
        <Box>
          <SecondaryText
            additionalStyles="margin: 0.5rem"
            fontSize="1rem"
            fontWeight="500"
          >
            List of faqs attached to this article
          </SecondaryText>
          <AttachedFaqsSection>
            {
              listAttachedFaqs
            }
          </AttachedFaqsSection>
        </Box>
        <Box>
          <SecondaryText
            additionalStyles="margin: 0.5rem"
            fontSize="1rem"
            fontWeight="500"
          >
            List of FAQ's present in the database.
          </SecondaryText>
          <ListedFaqsSection>
            <Search
              setFaqData={setFaqData}
              totalResults={faqsList?.length}
            />
            <ListedFaqs>
              {
                listFaqs
              }
            </ListedFaqs>
          </ListedFaqsSection>
        </Box>
      </FaqsListingContainer>
      {
        toggleAddFaqPopup && (
          <DialogBox
            dialogStatus={toggleAddFaqPopup}
            toggleDialog={setToggleAddFaqPopup}
          >
            <AddFaq
              attachNewFaq={attachNewFaq}
              contentId={contentId}
              setFaqData={setFaqData}
              setToggleAddFaqPopup={setToggleAddFaqPopup}
              token={token}
            />
          </DialogBox>
        )
      }
      {
        toggleEditFaqPopup && (
          <DialogBox
            dialogStatus={toggleEditFaqPopup}
            toggleDialog={setToggleEditFaqPopup}
          >
            <EditFaq
              contentId={contentId}
              editFaq={editFaq}
              setFaqData={setFaqData}
              setToggleEditFaqPopup={setToggleEditFaqPopup}
              token={token}
            />
          </DialogBox>
        )
      }
    </FaqsWrapper>
  );
};

const FaqsWrapper = styled.div`
  padding-top: 1.5rem;
  margin-top: 2rem;
  border-top: 1px solid ${colors.athensGray};
`;

const FaqsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
`;

const CreateFaqButton = styled.button`
  background-color: ${colors.primary};
  border: 1px solid ${colors.primary};
  color: #fff;
  padding: 0.5rem 1.5rem;
  border-radius: 0.2rem;
  font-size: 1rem;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  &:hover {
    color: ${colors.primary};
    background-color: #fff;
  }
`;

const Box = styled.div``;

const FaqsListingContainer = styled.div`
  display: flex;
  gap: 2rem;
  align-items: start;

  & > div {
    width: 50%;
    & > div {
      height: 400px;
      max-height: 400px;
      overflow: auto;
      background-image: linear-gradient(133deg, #6725f412, #6725f408);
      border-radius: 0.4rem;
    }
  }
`;

const AttachedFaqsSection = styled.div`

`;

const ListedFaqsSection = styled.div`
  position: relative;
`;

const ListedFaqs = styled.ul`
  padding: 0;
`;

export default ManageBlogFaqs;
